export default __webpack_public_path__ + "static/media/title.e346808a.png";